export const headerConfig = {
  top5PriceDecrease: [
    { title: "Rank" },
    { title: "Token" },
    { title: "Price Changed 24h", tooltip: "Price decreased in the last 24h" },
  ],
  top5PriceIncrease: [
    { title: "Rank" },
    { title: "Token" },
    { title: "Price Changed 24h", tooltip: "Price increased in the last 24h" },
  ],
  top5PriceStable: [
    { title: "Rank" },
    { title: "Token" },
    { title: "Price Stability", tooltip: "Represents the stability of token’s price in 100 days." },
  ],
  top5AvgIncreasingScore: [{ title: "Rank" }, { title: "Token" }, { title: "Average Score" }],
};
